import React from "react";
import {Box, Chip, CircularProgress, Tooltip} from "@mui/material";
import Face5Icon from "@mui/icons-material/Face5";

export default function ChildBriefChip({index, isDataLoading, handleChipIconHovered}) {

    const childContainerStyle = {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginRight: '-0.6rem',
        whiteSpace: 'nowrap'
    };

    const childChipStyle = {
        display: 'flex',
        width: '60%',
        marginLeft: '0.1rem',
        marginRight: '-0.8rem',
        overflow: 'hidden',
        backgroundColor: 'rgba(255, 255, 255, 0.8)'
    };

    const genericChildChipIcon = <Box sx={{display: 'flex', paddingLeft: '0.5rem'}}><Face5Icon /></Box>;

    return (<Box sx={childContainerStyle}>
        <Tooltip title={isDataLoading ? <CircularProgress size={20} sx={{color: 'white'}}/> : null}>
            <Chip key={index} onMouseEnter={handleChipIconHovered} icon={genericChildChipIcon} size="small" sx={childChipStyle} />
        </Tooltip>
    </Box>);
}
